export enum TimeFormat {
  HoursMinutes = 0, // 05:59
  HoursAndDecimals = 1, // 5.99
}
